import gql from 'graphql-tag';

export const GET_AIRLINES = (org_id: string) => gql`
  query GetAirlines${org_id.replace(new RegExp(':', 'g'), '_')} {
    airlines {
      airlines {
        airline_name
        iata_code
        airline_possessive
        prod_organization
        preview_organization
      }
    }
  }
`

export const START_WORKFLOW_ABOVE_DEFAULT = gql`mutation start_workflow_above_default($aspect_ratio: String, $email_notification: [AWSEmail!], $email_notification_publish: [AWSEmail!], $filename: String!, $input_brefix: String!, $po_item_id: String!, $po_name: String!, $tracks: [TrackInput!]!, $vtk_template: String!, $watermark: Boolean = false, $po_destination: String, $format_specific_data: AWSJSON, $auto_publish: Boolean) {
  start_workflow_above_default(input: {aspect_ratio: $aspect_ratio, filename: $filename, po_item_id: $po_item_id, email_notification: $email_notification, email_notification_publish: $email_notification_publish, po_name: $po_name, vtk_template: $vtk_template, watermark: $watermark, input_brefix: $input_brefix, tracks: $tracks, po_destination: $po_destination, format_specific_data: $format_specific_data, auto_publish: $auto_publish}) {
    state
    message
    input
    data
    action
    id
    start_date
    end_date
  }
}
`

export const START_WORKFLOW_DEFAULT = gql`mutation start_workflow_default($aspect_ratio: String, $email_notification: [AWSEmail!], $email_notification_publish: [AWSEmail!], $filename: String!, $content_identifier: String!, $po_item_id: String!, $po_name: String!, $tracks: [TrackInput!]!, $vtk_template: String!, $watermark: Boolean = false, $po_destination: String!, $metadata_source: String, $wrap_up_workflow: String, $format_specific_data: AWSJSON, $auto_publish: Boolean) {
  start_workflow_default(input: {aspect_ratio: $aspect_ratio, filename: $filename, po_item_id: $po_item_id, email_notification: $email_notification, email_notification_publish: $email_notification_publish, po_name: $po_name, vtk_template: $vtk_template, watermark: $watermark, content_identifier: $content_identifier, tracks: $tracks, po_destination: $po_destination, format_specific_data: $format_specific_data, auto_publish: $auto_publish, metadata_source: $metadata_source, wrap_up_workflow: $wrap_up_workflow}) {
    state
    message
    input
    data
    action
    id
    start_date
    end_date
  }
}
`

export const START_WORKFLOW_VOD_DEFAULT = gql`mutation start_workflow_vod_default   ( $po_item_id: String!, $po_name: String!, $input_brefix: String!, $po_destination: String!, $auto_publish: Boolean!, $vtk_template: String!, $format_specific_data: AWSJSON!, $email_notification: [AWSEmail!]) {
  start_workflow_vod_default(input: {  po_name: $po_name, po_item_id: $po_item_id, input_brefix: $input_brefix, po_destination: $po_destination, auto_publish: $auto_publish, email_notification: $email_notification, vtk_template: $vtk_template, format_specific_data: $format_specific_data}) {
    state
    message
    input
    data
    action
    id
    start_date
    end_date
  }
}
`

export const PUBLISH_PO_ITEM = gql`mutation PublishPoItem($po_name: String!, $po_item_id: String!) {
  publishPoItem(input: { po_name: $po_name, po_item_id: $po_item_id }) {
    __typename
    id
    state
    data
    message
    start_date
    end_date
  }
}`

export const RESTART_WORKFLOW = gql`mutation RestartWorkflow($po_name: String!, $po_item_id: String!) {
  restartPoItem(input: {po_name:$po_name, po_item_id:$po_item_id}) {
    id
    state
    message
    start_date
    end_date
  }
}`

export const PO_ITEM_LIST_FULL = (org_id: string) => gql`query PoItemListFull${org_id.replace(new RegExp(':', 'g'), '_')}($po_name: String!) {
  list_POs(input: { filter: { po_name: { eq: $po_name } } } ){
    __typename
    pos {
      id
      po_name
      airline
      finalize_process {
        id
        message
        state
        data
      }
      __typename
      poitems {
        __typename
        input_brefix
        filename
        id
        po_item_id
        po_destination
        output_brefix
        content_identifier
        po {
          id
          airline
          po_name
        }
        publish_process {
          id
          state
          data
          message
          start_date
          end_date
        }
        workflow_process {
          id
          state
          data
          message
          start_date
          end_date
        }
        customer
        vtk_template
        watermark
        workflow
        aspect_ratio
        format_specific_data
        format_specific_data_json  @client
        preview {
          dash_manifest_last_modified
          dash_manifest_url
          hls_manifest_url
          hls_manifest_last_modified
        }
        tracks {
          codec_type
          messages
          source {
            codec_type
            index
            key
            lang
          }
          lang
        }
        checkpoint_content_uploaded
        checkpoint_content_complete
        checkpoint_encodes_done
        checkpoint_metadata_available
        vtk_jobs {
          created
          organization_id
          organization_urn
          id
          job_bundle
          modified
          status_text
          tags
        }
      }
    }
  }
}`

export const GET_SINGLE_PO_ITEM = (org_id: string) =>  gql`query GetSinglePoItem${org_id.replace(new RegExp(':', 'g'), '_')}($po_name: String!, $po_item_id: String!) {
  list_POs(input: { filter: { po_name: { eq: $po_name } } } ){
    __typename
    pos {
      id
      po_name
      airline
      finalize_process {
        id
        message
        state
      }
      __typename
      poitems(po_item_id: $po_item_id) {
        __typename
        input_brefix
        filename
        id
        po_item_id
        po_destination
        output_brefix
        content_identifier
        po {
          id
          airline
          po_name
        }
        publish_process {
          id
          state
          data
          message
          start_date
          end_date
        }
        workflow_process {
          id
          state
          data
          message
          start_date
          end_date
        }
        customer
        vtk_template
        watermark
        workflow
        aspect_ratio
        format_specific_data
        format_specific_data_json  @client
        preview {
          dash_manifest_last_modified
          dash_manifest_url
          hls_manifest_url
          hls_manifest_last_modified
        }
        tracks {
          codec_type
          messages
          source {
            codec_type
            index
            key
            lang
          }
          lang
        }
        checkpoint_content_uploaded
        checkpoint_content_complete
        checkpoint_encodes_done
        checkpoint_metadata_available
        vtk_jobs {
          created
          organization_id
          organization_urn
          id
          job_bundle
          modified
          status_text
          tags
        }
        metadata_source
        wrap_up_workflow
        email_notification
        email_notification_publish
        encode_location
        publish_reports(format: JSON)
      }
    }
  }
}`

export const PO_ITEM_LIST_DELIVERIES = (org_id: string) => gql`query PoItemListDeliveries${org_id.replace(new RegExp(':', 'g'), '_')}($po_name: String!, $po_item_id: String, $format: ReportFormat) {
  list_POs(input: { filter: { po_name: { eq: $po_name } } } ){
    __typename
    pos {
      id
      finalize_process {
        state
        message
        id
      }
      __typename
      poitems(po_item_id: $po_item_id)  {
        __typename
        publish_reports(format: $format)
      }
    }
  }
}`

export const PO_LIST_DELIVERIES = (org_id: string) => gql`query PoListDeliveries${org_id.replace(new RegExp(':', 'g'), '_')}($po_name: String!, $format: ReportFormat) {
  list_POs(input: { filter: { po_name: { eq: $po_name } } } ){
    __typename
    pos {
      id
      finalize_process {
        state
        message
        id
      }
      finalize_reports(format: $format)
      __typename
    }
  }
}`

export const LIST_POS = (org_id: string) => gql`
  query GetPOs${org_id.replace(new RegExp(':', 'g'), '_')}($airline: String!, $date_created: FilterAWSDateTimeInput) {
    list_POs(input: { filter: { airline: { eq: $airline }, date_created: $date_created }}){
      pos {
        id
        airline
        po_name
        date_due
        date_created
        target_system
        finalize_process {
          id
          message
          state
        }
      }
    }
  }`
